import { consumeLoading } from "@/lib/consume/loading"
import { consumeUseRouter } from "@/lib/consume/useRouter"
import { RoutingContainerComponent } from "@/lib/routing/container/component"

export const RoutingContainerConsumer = consumeLoading(
  consumeUseRouter()(RoutingContainerComponent)
)
